import React from 'react';
import styles from './approval.module.scss';
import { useTranslation } from 'next-i18next';

export default function ListingsBannerApproval(): JSX.Element {
  const { t } = useTranslation('components:pages:listings:banner-approval');

  return (
    <div className={styles.approval}>
      <p className={styles.approval_text}>{t('TEXT_BEFORE_GAINING_FULL_ACCESS')}</p>
      <ul className={styles.approval_list}>
        <li>{t('TEXT_APPROVAL_TYPICALLY_TAKES')}</li>
        <li>{t('TEXT_IF_ADDITIONAL_INFORMATION')}</li>
        <li>{t('TEXT_IF_YOU_HAVE_NOT_HEARD')}</li>
      </ul>
    </div>
  );
}
